import { DialogActions, DialogTitle } from "@mui/material";
import React, { Component } from "react";
import { Trans, withTranslation } from "react-i18next";

import { WorkspaceUserRole } from "common/interfaces";
import { getStaticUrl } from "js/config";
import AppController from "js/core/AppController";
import getLogger from "js/core/logger";
import {
    BeautifulDialog,
    DialogContent,
    ShowErrorDialog
} from "js/react/components/Dialogs/BaseDialog";
import { BlueButton, BlueOutlinedButton } from "js/react/components/UiComponents";
import FetchingClickShield from "js/react/components/FetchingClickShield";

const logger = getLogger();

class MemberAddedToWorkspaceDialog extends Component {
    state = {
        fetching: false
    };

    handleJoinTeam = async () => {
        const { notification: { id, event: { teamInviteUrl } } } = this.props;
        const { t } = this.props;

        try {
            this.setState({ fetching: true });
            await AppController.notificationsService.markAsRead(id);
            window.open(teamInviteUrl, "_self");
        } catch (err) {
            logger.error(err, "[MemberAddedToWorkspaceDialog] AppController.notificationsService.markAsRead() failed", { id });

            ShowErrorDialog({
                error: t("Error joining team"),
                message: err.message
            });
        }
    }

    handleClose = async () => {
        const { closeDialog, notification: { id } } = this.props;

        try {
            this.setState({ fetching: true });
            await AppController.notificationsService.markAsRead(id);
        } catch (err) {
            logger.error(err, "[MemberAddedToWorkspaceDialog] AppController.notificationsService.markAsRead() failed", { id });
        }

        closeDialog();
    }

    render() {
        const { notification: { id, event: { triggeredByUser, teamName, toUserRole } } } = this.props;
        const { fetching } = this.state;
        const { t } = this.props;

        return (
            <BeautifulDialog>
                <FetchingClickShield visible={fetching} backgroundColor="white" />
                <img style={{ width: 50, margin: "20px auto 0" }} src={getStaticUrl("/images/invite-icon.svg")} />
                <DialogTitle>{t("Join the team!")}</DialogTitle>
                <DialogContent>
                    <p>
                        <Trans
                            t={t}
                            i18nKey="{{name}} has invited you to join <team>{{teamName}}</team>."
                            values={{ name: triggeredByUser.displayName, teamName }}
                            components={{ team: <span style={{ color: "#159bcd", fontWeight: 900 }} /> }}
                        />
                    </p>
                    <p>
                        {toUserRole === WorkspaceUserRole.OWNER && t("You have been asked to join as an Owner, which means you'll have the ability to manage the team, team slides and theme.")}
                        {toUserRole === WorkspaceUserRole.LIBRARIAN && t("You have been asked to join as a Librarian, which means you'll have the ability to manage team slides and theme.")}
                        {toUserRole === WorkspaceUserRole.MEMBER && t("Now you can build decks together, faster. Keep everything in one place and everyone on brand with team slides and theme.")}
                    </p>
                </DialogContent>
                <DialogActions>
                    <BlueOutlinedButton onClick={this.handleClose}>
                        {t("Maybe Later")}
                    </BlueOutlinedButton>
                    <BlueButton onClick={this.handleJoinTeam}>
                        {t("Join Now")}
                    </BlueButton>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}

export default withTranslation()(MemberAddedToWorkspaceDialog);
